import { SvgIcon } from '@mui/material';

const EuropeanService = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_172' data-name='Group 172' transform='translate(-453 -460)'>
      <circle
        id='Ellipse_7'
        data-name='Ellipse 7'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(453 460)'
        fill='#fff'
      />
      <path
        id='Path_87'
        data-name='Path 87'
        d='M6.851,0A6.851,6.851,0,1,0,13.7,6.851,6.878,6.878,0,0,0,6.851,0Zm3.971,4.095a.4.4,0,1,1-.147.548A.4.4,0,0,1,10.822,4.095ZM6.851,1.632a.4.4,0,1,1-.4.4A.4.4,0,0,1,6.851,1.632Zm-2.609.7a.4.4,0,1,1-.147.548A.4.4,0,0,1,4.242,2.332ZM1.632,6.851a.4.4,0,1,1,.4.4A.4.4,0,0,1,1.632,6.851ZM2.88,9.607a.4.4,0,1,1,.147-.548A.4.4,0,0,1,2.88,9.607Zm.147-4.964a.4.4,0,1,1-.147-.548A.4.4,0,0,1,3.027,4.643Zm1.763,6.58a.4.4,0,1,1-.147-.548A.4.4,0,0,1,4.79,11.223Zm.857-4.774a.4.4,0,0,1,0,.8h-.4v.8h.4a.4.4,0,0,1,0,.8h-.8a.4.4,0,0,1-.4-.4V5.245a.4.4,0,0,1,.4-.4h.8a.4.4,0,0,1,0,.8h-.4v.8Zm1.2,5.62a.4.4,0,1,1,.4-.4A.4.4,0,0,1,6.851,12.069Zm0-4.416V5.245a.4.4,0,0,1,.8,0V7.654a.4.4,0,0,0,.8,0V5.245a.4.4,0,0,1,.8,0V7.654a1.2,1.2,0,0,1-2.408,0ZM9.46,11.37a.4.4,0,1,1,.147-.548A.4.4,0,0,1,9.46,11.37Zm.147-8.49a.4.4,0,1,1-.147-.548A.4.4,0,0,1,9.607,2.88ZM11.37,9.46a.4.4,0,1,1-.147-.548A.4.4,0,0,1,11.37,9.46Zm.3-2.208a.4.4,0,1,1,.4-.4A.4.4,0,0,1,11.668,7.252Z'
        transform='translate(458.649 465.649)'
        fill='#dc0132'
      />
    </g>
  </SvgIcon>
);

export default EuropeanService;
